import { formatPhoneNumber } from '~/components/ui/inputs/phoneNumber';
import { formatDateTime } from '~/utils';

export type CsvUser = {
  firstName: string;
  lastName: string;
  externalId?: string | null;
  phoneNumber?: string | null;
  roleLabel: string;
  statusLabel: string;
  lastEditedBy?: { firstName: string; lastName: string } | null;
  lastEditedAt?: string | null;
};

const SPREADSHEET_FORMULA_PREFIX = /^[=+\-@\t\r]/;

export function neutralizeSpreadsheetFormula(text: string): string {
  return SPREADSHEET_FORMULA_PREFIX.test(text) ? `'${text}` : text;
}

export type CsvUserWithOrganization = CsvUser & { organizationName: string };

export const ALL_LINKED_ORGANIZATION_USERS_CSV_FILENAME =
  'linked-organizations-users.csv';

export function linkedOrganizationUsersCsvRows(users: CsvUser[]): string[][] {
  return users.map(userCsvColumns);
}

export function allLinkedOrganizationUsersCsvRows(
  users: CsvUserWithOrganization[]
): string[][] {
  return users.map((user) => [
    neutralizeSpreadsheetFormula(user.organizationName),
    ...userCsvColumns(user),
  ]);
}

function userCsvColumns(user: CsvUser): string[] {
  return [
    neutralizeSpreadsheetFormula(`${user.firstName} ${user.lastName}`),
    neutralizeSpreadsheetFormula(user.externalId ?? ''),
    user.phoneNumber
      ? neutralizeSpreadsheetFormula(formatPhoneNumber(user.phoneNumber))
      : '',
    neutralizeSpreadsheetFormula(user.roleLabel),
    neutralizeSpreadsheetFormula(user.statusLabel),
    user.lastEditedBy
      ? neutralizeSpreadsheetFormula(
          `${user.lastEditedBy.firstName} ${user.lastEditedBy.lastName}`
        )
      : '',
    user.lastEditedAt ? formatDateTime(user.lastEditedAt) : '',
  ];
}

export function linkedOrganizationUsersCsvFilename(
  organizationName: string
): string {
  const slug = organizationName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return `${slug === '' ? 'organization' : slug}-users.csv`;
}
